/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { RequestEmailOtpDto } from '../model/requestEmailOtpDto';
import { RequestSmsOtpDto } from '../model/requestSmsOtpDto';
import { RequestVerifyOtpDto } from '../model/requestVerifyOtpDto';
import { ResponseOtpDto } from '../model/responseOtpDto';
import { ResponseVerifyOtpDto } from '../model/responseVerifyOtpDto';
import { ValidationError } from '../model/validationError';


@Injectable({
  providedIn: 'root',
})
export class OtpService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   */
  public otpRequestEmailPost$(body: RequestEmailOtpDto): Observable<ResponseOtpDto> {
    return this.api.post(`${apiBaseUrl()}/otp/request-email`, body, undefined, true);
  }
  /**
   */
  public otpRequestSmsPost$(body: RequestSmsOtpDto): Observable<ResponseOtpDto> {
    return this.api.post(`${apiBaseUrl()}/otp/request-sms`, body, undefined, true);
  }
  /**
   */
  public otpVerifyPost$(body: RequestVerifyOtpDto): Observable<ResponseVerifyOtpDto> {
    return this.api.post(`${apiBaseUrl()}/otp/verify`, body, undefined, true);
  }
}
